const config = {
    baseUrl: 'https://localhost:3035',
};

export default config;
